function isBulgarian(language) {
  return 0 === "BG".localeCompare(language);
}

function getOrderPrefix(language) {
  return isBulgarian(language)
    ? "Вашата поръчка №"
    : "Your order #";
}

export function buildExecutedOrderMessage(orderData, language, dateFormatter, orderTypeFormatter, stockNameResolver) {
  let message = getOrderPrefix(language);
  message = message + orderData.id + ", " + dateFormatter(orderData.d) +
    ", " + orderTypeFormatter(orderData.t) + " " + orderData.sc + "(" + stockNameResolver(orderData.sc) + ") " +
    orderData.qty + "@" + orderData.sp + " " + orderData.cc;

  return isBulgarian(language)
    ? message + " е изпълнена"
    : message + " is completed";
}

export function buildRejectedOrderMessage(orderData, language, dateFormatter) {
  const stockName = orderData.nBG
    ? orderData.nBG
    : orderData.nEN;
  let message = getOrderPrefix(language);
  message = message + orderData.oid + ", " + dateFormatter(orderData.ts) +
    ", " + orderData.sc + "(" + stockName + ") " +
    orderData.qty + "@" + orderData.sp + " " + orderData.cc;

  return isBulgarian(language)
    ? message + " е отказана"
    : message + " is rejected";
}
